export enum SegmentPosition {
  Left,
  Center,
  Right
}
